export const reportsStoreKey = 'reports';
